<template>
<div class="chapter">
<div class="inner_page">
<h1>Trials of the Major War</h1>
<h3 class="sigil_not_in_toc">Criminals Before the International</h3>
<h3 class="sigil_not_in_toc">Military Tribunal  Volume 11</h3>
<h4 class="sigil_not_in_toc">Nuremburg 14 November 1945-1 October 1946</h4>
<h2 class="sigil_not_in_toc">Various</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?4ada3708